import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DayStartEndPageRoutingModule } from './day-start-end-routing.module';

import { DayStartEndPage } from './day-start-end.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, DayStartEndPageRoutingModule, TranslateModule.forChild()],
  declarations: [DayStartEndPage]
})
export class DayStartEndPageModule {}
